'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = require('./');

var parse = function parse(value) {
  return (0, _.isJson)(value) ? JSON.parse(value) : value;
};

exports.default = parse;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/parse.js